export const toPascal = (str: string) => {
  return str
    ?.toLowerCase()
    ?.replace(/\w+/g, (w) => w[0]?.toUpperCase() + w?.slice(1)?.toLowerCase());
};
